module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-intro-home"
  }, [_c('div', {
    staticClass: "block-intro-home__bg"
  }, [_c('div', {
    staticClass: "block-intro-home__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "block-intro-home__title",
    class: {
      "block-intro-home__title--active": _vm.fadeTitle
    }
  }, [_vm._v("Central Ohio"), _c('br'), _c('span', {
    staticClass: "block-intro-home__title--option"
  }, [_vm._v("Orthodontics")])]), _vm._m(0), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointLine,
        options: _vm.intersectionLineOptions
      }),
      expression: "{ active: true, callback: onWaypointLine, options: intersectionLineOptions }"
    }],
    staticClass: "block-intro-home__seperator",
    class: {
      "block-intro-home__seperator--active": _vm.fadeLine
    }
  }, [_c('div', {
    staticClass: "block-intro-home__orange-line"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-intro-home__row"
  }, [_c('div', {
    staticClass: "block-intro-home__content"
  }, [_vm._v("It’s time to shine! While we work towards the goal of a straighter smile, Doctor Miller and the COO team make it their personal mission to brighten each patient’s day while in the office. A beautiful smile and an uplifting atmosphere instills confidence in each of our patients which makes them smile bigger and shine brighter. Our patients shine inside and out!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f0c3b64","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-intro-home/block-intro-home.pug
// module id = 573
// module chunks = 1